import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bf68ea9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "初期パスワード更新")
], -1))
const _hoisted_2 = {
  id: "change-password-form",
  class: "card"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "new-password" }, "新しいパスワード", -1))
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "confirm-password" }, "新しいパスワードをもう一度入力してください。", -1))
const _hoisted_8 = { class: "mt-5" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onKeyup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
          class: "card-body"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.newPassword }]),
              id: "new-password",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.newPassword) = $event)),
              autocomplete: "new-password"
            }, null, 2), [
              [_vModelText, _ctx.values.newPassword]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.newPassword)
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control",
              id: "confirm-password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmPassword) = $event))
            }, null, 512), [
              [_vModelText, _ctx.confirmPassword]
            ])
          ]),
          _createVNode(_component_response_result_alert, {
            "error-message": _ctx.requestError,
            onDismiss: _ctx.dismissAlert,
            "is-succeed": _ctx.isSucceed,
            "success-message": "パスワードを更新しました。"
          }, null, 8, ["error-message", "onDismiss", "is-succeed"]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger float-right",
              disabled: !_ctx.meta.valid,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updatePassword && _ctx.updatePassword(...args)))
            }, "パスワード更新", 8, _hoisted_9)
          ])
        ], 32)
      ])
    ]),
    _: 1
  }))
}